import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouterProps } from '../../../utils/with-router-props'

import { callApi, fetchApiDataIfNeeded } from '../../../../actions/api'
import { apiResourceEndpoint } from '../../../../constants/routes'
import { formatCurrency } from '../../../utils/formatters'

import moment from 'moment'

const mapStateToProps = (state, ownProps) => {
    return {
        receipt: state.adminReceipts.find(receipt => receipt.id === Number(ownProps.params.receiptId))
    }
}

const ViewRecipt = ({ dispatch, params, receipt }) => {
    const receiptId = params.receiptId

    useEffect(() => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/receipts', 'VIEW', receiptId)))
    }, [dispatch, receiptId])

    if (!receipt) {
        return null
    }

    const handleDelete = () => {
        const confirmDelete = window.confirm('Are you sure you want to delete this receipt?')
        if (confirmDelete) {
            dispatch(callApi(apiResourceEndpoint('admin/receipts', 'DELETE', receiptId), {}, -1))
        }
    }

    return (
        <div className="box">
            <h1>View Receipt</h1>
            <p>View the details of the receipt below</p>
            <div>
                <h2>Receipt Details</h2>
                <p>Net: {formatCurrency(receipt.net, 2, 2)}</p>
                <p>Gross: {formatCurrency(receipt.gross, 2, 2)}</p>
                <p>Fees: {formatCurrency(receipt.fees, 2, 2)}</p>
                <p>Vendor: {receipt._computed.vendorName}</p>
                <p>Received On: {moment(receipt.receivedOn).format('ddd. MMMM DD, Y')}</p>
                <p>
                    <span className="clickable" onClick={handleDelete}>
                        Delete Received Commission
                    </span>
                </p>
            </div>
        </div>
    )
}

export default withRouterProps(connect(mapStateToProps)(ViewRecipt))
